import { theme } from '@primerai/thread';
import { createGlobalStyle } from 'styled-components';

// see also the styles in the /public/index.html file
export default createGlobalStyle`

  /* Base Sizing for REM */
  html {
    font-size: 1rem;
  }

  body {
    background: ${theme.colors.$background.elevation1};
    color: ${theme.colors.$text.default};
    font-family: IBM Plex Sans,system-ui,sans-serif;
    font-size: 1rem;
  }

  /* vertical height support */
  html, body, #root { width: auto; height: 100%; -webkit-font-smoothing: antialised; }
  #root {
    display: flex;
    flex-direction: column;
  }

  /* Additional Normalizing */

  *,
  :after,
  :before {
    box-sizing: border-box;
  }

  * {
    outline: 0 !important;
  }

  a:active,
  a:focus,
  a:hover {
    outline: 0;
    text-decoration: none;
  }

  figure {
    margin: 0;
  }

  a,
  [role='button'] {
    cursor: pointer;
  }

  /* TODO move into Spacer or own component */
  hr {
    margin-top: ${theme.space.$6};
    margin-bottom: ${theme.space.$6};
    border: 0;
    border-top: ${theme.borders.$default};
  }

  /* TODO move into own component to make more explicit */
  p {
    line-height: 1.5;
    margin: 0 0 10px;
  }

  h1, h2, h3, h4, h5, h6 {
    color: inherit;
    font-family: inherit;
    line-height: 1.1;
    margin: 0;
  }

  h1 {
    font-size: ${theme.fontSizes.$7};
    font-weight: ${theme.fontWeights.$semibold};
  }

  h2 {
    font-size: ${theme.fontSizes.$6};
    font-weight: ${theme.fontWeights.$semibold};
  }

  h3 {
    font-size: ${theme.fontSizes.$5};
    font-weight: ${theme.fontWeights.$semibold};
  }

  h4 {
    font-size: ${theme.fontSizes.$4};
    font-weight: ${theme.fontWeights.$semibold};
  }

  h5 {
    font-size: ${theme.fontSizes.$3};
    font-weight: ${theme.fontWeights.$semibold};
  }

  h6 {
    font-size: ${theme.fontSizes.$3};
    font-weight: ${theme.fontWeights.$semibold};
  }

  body input {
    font-family: IBM Plex Sans,system-ui,sans-serif !important;
    color: ${theme.colors.$text.strong}
  }
`;
